import React, { useEffect, useState } from "react";
import './assignments.css';
import Loading1 from "../loading_animation/loading";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks"; 


export default function AssignmentSubmit() {
  const [config, setConfig] = useState(null);
  const [username, setUsername] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userDomain, setUserDomain] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [assignments, setAssignments] = useState([]);
  const [selectedAssignment, setSelectedAssignment] = useState(null);

  const [answerText, setAnswerText] = useState("");
  const [answerFile, setAnswerFile] = useState(null);
  const [userApplicationId, setUserApplicationId] = useState("");
  const [submittedAnswers, setSubmittedAnswers] = useState([]);



  useEffect(() => {
      fetch("/config.json")
        .then(res => res.json())
        .then(data => setConfig(data))
        .catch(err => console.error("Error loading config:", err));
    }, []);

  useEffect(() => {
    if (!config) return;

    const fetchUserData = async () => {
      try {
        const res = await fetch(
          `${config.BASE_URL}${config.USER_INFO}`,
          {
            method: "POST",
            credentials: "include",
          }
        );
        const data = await res.json();
        if (data.success) {
          setUsername(data.fullname);
          setUserEmail(data.email);
        }
      } catch (err) {
        console.error("User fetch err:", err);
      }

      try {
        const res2 = await fetch(
          `${config.BASE_URL}${config.CHECK_INTERNSHIP}`,
          {
            method: "POST",
            credentials: "include",
          }
        );
        const data2 = await res2.json();

        if (data2.success) {
          if (data2.applications?.length > 0) {
            const details = data2.applications[0];
            setUserDomain(details.domain);
            setUserApplicationId(details.application_id); 
          }
        }
      } catch (err) {
        console.error("Internship check err:", err);
      }
    };

    fetchUserData();
  }, [config]);

useEffect(() => {
  if (!config || !userApplicationId) return; 

  const fetchAssignments = async () => {
    try {
      const formData = new FormData();
      formData.append("application_id", userApplicationId);

      const res = await fetch(`${config.BASE_URL}${config.GET_ASSIGNMENTS}`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      const data = await res.json();
      if (data.success) {
        setAssignments(data.assignments);
      }
    } catch (err) {
      console.error("Assignments fetch err:", err);
    }
  };

  fetchAssignments();
}, [config, userApplicationId]);

  // Filter assignments by user domain
  const filteredAssignments = assignments

  // Submit answer
  const handleSubmit = async () => {
    if (!selectedAssignment) return alert("Select an assignment");
    if (!answerText && !answerFile)
      return alert("Please write an answer or upload file");

    const formData = new FormData();
    formData.append("assignment_id", selectedAssignment.assignment_id);
    formData.append("application_id", userApplicationId);
    formData.append("answer", answerText);
    if (answerFile) formData.append("file", answerFile);

    try {
      setIsLoading(true);
      const res = await fetch(
        `${config.BASE_URL}${config.SUBMIT_ASSIGNMENT}`,
        {
          method: "POST",
          credentials: "include",
          body: formData,
        }
      );
      const data = await res.json();
      if (data.success) {
        alert("Answer submitted successfully!");
        setAnswerText("");
        setAnswerFile(null);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Submit error:", error);
    }finally {
      setIsLoading(false);
    }
  };


useEffect(() => {
  if (!config || !userApplicationId) return;

  const fetchSubmittedAnswers = async () => {
    try {
      const formData = new FormData();
      formData.append("application_id", userApplicationId);

      const res = await fetch(`${config.BASE_URL}${config.MARKS_SECURED}`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      const data = await res.json();
      if (data.success) {
        setSubmittedAnswers(data.answers);
      }
    } catch (err) {
      console.error("Submitted answers fetch err:", err);
    }
  };

  fetchSubmittedAnswers();
}, [config, userApplicationId]);


const passedCount = submittedAnswers.filter(ans => 
  ans.marks_secured !== null && ans.total_marks !== null && ans.marks_secured >= ans.total_marks / 2
).length;

const failedCount = submittedAnswers.filter(ans => 
  ans.marks_secured !== null && ans.total_marks !== null && ans.marks_secured < ans.total_marks / 2
).length;

const totalMarks = submittedAnswers.reduce(
  (sum, ans) => sum + (ans.total_marks ?? 0),
  0
);

const securedMarks = submittedAnswers.reduce(
  (sum, ans) => sum + (ans.marks_secured ?? 0),
  0
);

// Overall status logic
const overallStatus =
  totalMarks === 0
    ? "-"
    : securedMarks >= totalMarks / 2
    ? "Passed"
    : "Failed";

  return (
  <>
  {/* --- Submitted Answers Table --- */}
{submittedAnswers.length > 0 && (
  <div className="submitted-answers-table" style={{ padding: "30px" }}>
    <h3>Submitted Answers & Marks</h3>
    <table className="table table-bordered mt-2">
      <thead className="table-light">
        <tr>
          <th>Question ID</th>
          <th>Question Name</th>
          <th>Total Marks</th>
          <th>Marks Secured</th>
          <th>Remark</th>
        </tr>
      </thead>
      <tbody>
        {submittedAnswers.map((ans) => (
          <tr key={ans.answer_id}>
            <td>{ans.question_id}</td>
            <td>{ans.question_name}</td>
            <td>{ans.total_marks ?? "-"}</td>
            <td>{ans.marks_secured ?? "-"}</td>
            <td>{ans.remark ?? "-"}</td>
          </tr>
        ))}

        {/* --- Total Row --- */}
       <tr style={{ fontWeight: "600", background: "#f1f1f1" }}>
        <td colSpan={2}>Total</td>
        <td>{totalMarks}</td>
        <td>{securedMarks}</td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
)}

{submittedAnswers.length > 0 && (
  <div className="assignments-summary" style={{ marginTop: "20px" }}>
    <h4>Assignments Summary</h4>
    <p><strong>Passed:</strong> <span className="passed">{passedCount}</span></p>
    <p><strong>Failed:</strong> <span className="failed">{failedCount}</span></p>
    <tr style={{ fontWeight: "700", background: "#e9ecef" }}>
  <td colSpan={3}>Overall Result:</td>
  <td colSpan={2} 
      style={{ 
        color: overallStatus === "Passed" ? "green" : 
               overallStatus === "Failed" ? "red" : "black",
        fontWeight: "700"
      }}>
    {overallStatus}
  </td>
  </tr>
  </div>
)}


    <div className="assignment-submit-container" style={{ padding: "30px" }}>
      <h2>Submit Your Assignment</h2>

      {/* --- Dropdown --- */}
      <label style={{ fontWeight: "600" }}>Select Assignment</label>
      {filteredAssignments.length > 0 ? (
  <select
    className="form-control"
    onChange={(e) => {
      const selected = filteredAssignments.find(
        (a) => a.assignment_id === e.target.value
      );
      setSelectedAssignment(selected || null);
    }}
  >
    <option value="">Select Assignment</option>
    {filteredAssignments.map((a) => (
      <option key={a.assignment_id} value={a.assignment_id}>
        {a.question_name}
      </option>
    ))}
  </select>
) : (
  <p style={{ marginTop: "8px", color: "#555" }}>No assignments were assigned.</p>
)}

      {/* --- Assignment Details --- */}
      {selectedAssignment && (
        <div
          className="assignment-details"
          style={{
            marginTop: "20px",
            padding: "20px",
            background: "#f8f8f8",
            borderRadius: "12px",
          }}
        >
          <h3>{selectedAssignment.question_name}</h3>

          <ReactMarkdown
            children={selectedAssignment.question || "-"}
            remarkPlugins={[remarkGfm, remarkBreaks]}
            components={{
              p: ({ node, ...props }) => (
                <p
                  style={{ marginBottom: "10px", whiteSpace: "pre-wrap", lineHeight: "1.5" }}
                  {...props}
                />
              ),
              ul: ({ node, ...props }) => (
                <ul
                  style={{ paddingLeft: "20px", margin: "0 0 8px 0", listStyleType: "disc" }}
                  {...props}
                />
              ),
              ol: ({ node, ...props }) => (
                <ol
                  style={{ paddingLeft: "30px", margin: "0 0 8px 0", listStyleType: "decimal" }}
                  {...props}
                />
              ),
              li: ({ node, ...props }) => (
                <li style={{ marginBottom: "4px", lineHeight: "1.5" }} {...props} />
              ),
            }}
          />

          {/* Images */}
          <div style={{ display: "flex", gap: "12px", marginTop: "15px" }}>
            {[selectedAssignment.image1,
              selectedAssignment.image2,
              selectedAssignment.image3,
              selectedAssignment.image4]
              .filter(Boolean)
              .map((img, idx) => (
                <img
                  key={idx}
                  src={`/Assignment_images/${selectedAssignment.assignment_id}/${img}`}
                  alt="Assignment"
                  style={{
                    width: "180px",
                    borderRadius: "10px",
                    border: "1px solid #ddd",
                  }}
                />
              ))}
          </div>

          {/* Video */}
          {selectedAssignment.video && (
            <video
              controls
              style={{ width: "60%", marginTop: "20px", borderRadius: "10px" }}
            >
              <source
                src={`/Assignment_images/${selectedAssignment.assignment_id}/${selectedAssignment.video}`}
                type="video/mp4"
              />
            </video>
          )}

          {/* Answer Box */}
          <textarea
            className="form-control mt-3"
            rows={5}
            placeholder="Write your answer here..."
            value={answerText}
            onChange={(e) => setAnswerText(e.target.value)}
          ></textarea>

          {/* File Upload */}
         <div style={{ marginTop: "10px" }}>
          <input
            type="file"
            className="form-control"
            accept=".rar"
            onChange={(e) => setAnswerFile(e.target.files[0])}
          />
          <small style={{ display: "block", marginTop: "5px", color: "#555555" }}>
            upload your file only in .rar format
          </small>
        </div>

          <button
            className="btn btn-primary mt-4"
            onClick={handleSubmit}
          >
            Submit Answer
          </button>
        </div>
      )}
    </div>

        {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <Loading1 />
        </div>
      )}
  </>
);

}
